import { MainSection } from "./MainSection";

export function Home() {
  return (
    <main className="min-h-screen">
      <MainSection />
    </main>
  );
}
